import React from "react";
import ReactDOM from "react-dom/client";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
// import "rsuite/dist/rsuite-rtl.min.css";
import "./index.css";
import "./css/react-checkbox-tree.css";
import "./css/all.min.css";
import "react-toastify/dist/ReactToastify.css";

import App from "./App";
// import reportWebVitals from './reportWebVitals';
import RootProvider from "./context/RootContext";

import { QueryClient, QueryClientProvider } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { setupAxiosInterceptors } from "./services/axiosInterceptor";
import { startTokenAutoRefresh } from "./services/tokenAutoRefresh";

// Setup axios interceptors for automatic token refresh
setupAxiosInterceptors();
startTokenAutoRefresh();

// Optionally reload page when tokens are refreshed to refetch protected data
window.addEventListener("tokens-refreshed", () => {
  if (process.env.REACT_APP_RELOAD_ON_TOKEN_REFRESH === "true") {
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
let queryClient = new QueryClient();

root.render(
  <QueryClientProvider client={queryClient}>
    <RootProvider>
      <Router>
        <App />
      </Router>
    </RootProvider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
if (process.env.NODE_ENV === "production") {
  serviceWorkerRegistration.register();
} else {
  serviceWorkerRegistration.unregister();
}